<ul class="treeview" *ngIf="nodes.length">
  <li *ngFor="let node of nodes">
    <div class="{{node.class}}">
      <span *ngIf="node[childrenAttr].length" [ngClass]="{'node-opened': !node[collapseAttr]}">></span>
      <span [ngClass]="{'parent': node[childrenAttr].length}"
          (click)="click(node)">
        {{node.NAME}}
      </span>
    </div>
      <app-tree-view *ngIf="node[childrenAttr].length"
          [data]="node[childrenAttr]"
          [prepareData]="false"
          [ngbCollapse]="node[collapseAttr]"
          >
     </app-tree-view>
  </li>
</ul>

